export * from '@primeuix/themes/aura/dialog';
export { default } from '@primeuix/themes/aura/dialog';
